module.exports = __webpack_public_path__ + "assets/dd355edc06d30cec98f225e133a71a20.png";